import React from 'react';
import {
  CommonOnError, CommonScrollIntoView, CommonRequired
} from 'types/props';
import ValidationElement, {
  ValidationElementProps,
} from 'components/Form/ValidationElement/ValidationElement';
import classnames from 'classnames';
import { BranchCollectionModel } from 'forms/shared/types';
import BranchCollection from 'components/Form/BranchCollection';
import { MilitaryDisciplinaryProceduresItemModel } from 'forms/sections/military/disciplinary/types';
import { i18n } from 'config/locales';
import DisciplinaryCollectionItem from './DisciplinaryCollectionItem';

interface Props extends ValidationElementProps, BranchCollectionModel<MilitaryDisciplinaryProceduresItemModel> {
  attribute?: string;
  className?: string;
  formType?: string;
  onError?: CommonOnError;
  onUpdate: (values: BranchCollectionModel<MilitaryDisciplinaryProceduresItemModel>) => void;
  required?: CommonRequired;
  scrollIntoView?: CommonScrollIntoView;
}

export default class DisciplinaryCollection extends ValidationElement<Props> {
  updateBranch = (values: BranchCollectionModel<MilitaryDisciplinaryProceduresItemModel>) => {
    this.props.onUpdate({
      ...values,
    });
  };

  render() {
    return (
      <div className={classnames('disciplinary-list', this.props.className)}>
        {/* PVQ: Did you receive any disciplinary actions for this period [...]? */}
        {/* PVQ: Do you have another disciplinary action for this [...]? */}
        <BranchCollection
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...this.props}
          appendLabel={i18n.t('military.pvq.disciplinary.para.another')}
          appendSize="h4"
          label={i18n.t('military.pvq.disciplinary.para.info')}
          labelSize="h4"
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          onError={this.props.onError}
          onUpdate={this.updateBranch}
          scrollIntoView={this.props.scrollIntoView}
        >
          <DisciplinaryCollectionItem
            attribute={this.props.attribute}
            bind
            formType={this.props.formType}
            name="Item"
            required={this.props.required}
          />
        </BranchCollection>
      </div>
    );
  }
}
